import bellGif from "icons/bell/bell.gif"
import bellImg from "icons/bell/bell.jpg"

export default {
  gif: bellGif,
  img: bellImg,
}
